export default __webpack_public_path__ + "static/media/expand-more.0e066762.svg";